export const AUTH_V2_BASE_PATH = "/api/auth/v2";

// Přihlašovací identifikátor odesíláme beze změny domény. Odstraňujeme pouze
// nechtěné mezery z formuláře/password manageru.
export const normalizeAuthUsername = (username) =>
  String(username || "").trim();

export const AUTH_V2_ENDPOINTS = Object.freeze({
  checkToken: `${AUTH_V2_BASE_PATH}/checkToken`,
  firebaseConfig: `${AUTH_V2_BASE_PATH}/firebaseconfig`,
  login: `${AUTH_V2_BASE_PATH}/login`,
  loginAsIp: `${AUTH_V2_BASE_PATH}/LoginAsIp`,
  loginUrlKey: (urlKey) =>
    `${AUTH_V2_BASE_PATH}/LoginUrlKey/${encodeURIComponent(urlKey)}`,
  loginVerifyCode: `${AUTH_V2_BASE_PATH}/loginverifycode/withUser`,
  logout: `${AUTH_V2_BASE_PATH}/logout`,
  refreshToken: `${AUTH_V2_BASE_PATH}/refreshToken`,
  register: `${AUTH_V2_BASE_PATH}/register`,
});

export const USER_ENDPOINTS = Object.freeze({
  detail: (userId) => `/api/User/${encodeURIComponent(userId)}`,
});
